<script setup lang="ts">
import PrimeButton from 'primevue/button';
import { computed, inject } from 'vue';

import { toArrayClass } from 'lib/components/helpers';
import Icon from 'lib/components/icon/Icon.vue';

import type { ButtonProps } from './Button.vue.d';

const props = defineProps<ButtonProps>();
const Preset = inject<Record<string, any>>('preset', {}).button;

const iconProps = computed(() => ({
  icon: props.icon ?? 'check',
  class: [
    ...(Preset?.icon({ props: props }).class ?? {}),
    { 'text-base': props.icon && !props.label }, // Need to use attrs, because props.label is always undefined.
    ...toArrayClass(props.iconClass),
  ],
}));
</script>

<template>
  <PrimeButton
    v-if="tooltipPos === 'top'"
    v-tooltip.top="tooltip"
    v-bind="props"
    :icon="icon"
    :icon-pos="iconPos"
  >
    <template #icon="{ class: iconClass }">
      <Icon v-if="icon" v-bind="iconProps" :class="iconClass" />
    </template>

    <slot />
  </PrimeButton>

  <PrimeButton
    v-else-if="tooltipPos === 'left'"
    v-tooltip.left="tooltip"
    v-bind="props"
    :icon="icon"
    :icon-pos="iconPos"
  >
    <template #icon>
      <Icon v-if="icon" v-bind="iconProps" />
    </template>

    <slot />
  </PrimeButton>

  <PrimeButton
    v-else-if="tooltipPos === 'right'"
    v-tooltip.right="tooltip"
    v-bind="props"
    :icon="icon"
    :icon-pos="iconPos"
  >
    <template #icon>
      <Icon v-if="icon" v-bind="iconProps" />
    </template>

    <slot />
  </PrimeButton>

  <PrimeButton
    v-else
    v-tooltip.bottom="tooltip"
    v-bind="props"
    :icon="icon"
    :icon-pos="iconPos"
  >
    <template #icon>
      <Icon v-if="icon" v-bind="iconProps" />
    </template>

    <slot />
  </PrimeButton>
</template>
